module.exports = __webpack_public_path__ + "static/yuan_ti_broodguard-ea4ff3f94c70110bb1bdc6f1fb90ef4a.jpeg";